import { Box, Modal, Paper, Stack, Typography, useMediaQuery } from '@atd/rui-base.mui.all'
import { Button } from '@atd/rui-base.mui.button'
import { IconButton } from '@atd/rui-base.mui.icon-button'
import { Tooltip } from '@atd/rui-base.mui.tooltip'
import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'

import { CircularProgress } from '@atd/rui-base.mui.circular-progress'
import CloseIcon from '@mui/icons-material/Close'
import { ReportTable } from '@atd/one-slingshot.report.report-table'
import { format } from 'date-fns'
import { loadWorkorderAssociatedFiles } from '.././workorderActions'
import { styled } from '@mui/system'
import { useTheme } from '@mui/material/styles'

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'min(600px, 90vw)',
    bgcolor: 'background.paper',
    borderRadius: '5px',
    boxShadow: 24,
    paddingBottom: 2,
    overflowY: 'auto',
    maxHeight: '95vh',
}

const centeredText = {
    marginTop: '5px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}

const StyledTableNameCell = styled(ReportTable.Cell)({
    paddingLeft: '5px',
    paddingTop: '5px',
})

const displayCell = (file, column) => {
    if (column === 'Name') {
        const hostname = window.location.hostname.includes('local.ravenslingshot.com') ||
            window.location.hostname.includes('raven.engineering') ? 'raven.engineering' : 'ravenslingshot.com'
        const href =
            file.FileTypeId === 4 ? `https://apps.${hostname}/jobs/rxmap/${file.Id}` : `https://portal.${hostname}/index.php?r=fileMgmt/viewFile&id=${file.Id}`

        return <a href={href} style={{ color: 'var(--primary-light)' }} target={'_blank'}><span>{file.Name}</span> </a>
    }
    let displayString
    let tooltipString = ''
    if (column === 'FileTime') {
        const date = new Date(file[column]) ?? new Date()

        displayString = format(date, 'yyyy-MM-dd')
        tooltipString = format(date, 'yyyy-MM-dd HH:mm')

        if (displayString === '0001-01-01') {
            displayString = 'N/A'
        }
    }
    else {
        displayString = file[column]?.toString() || ''
    }
    if (tooltipString !== '') {
        return <Tooltip title={tooltipString}><span>{displayString}</span></Tooltip>
    }

    return <span>{displayString}</span>

}

function mapStateToProps(state) {
    return {
        fileTypes: state.admin.fileTypes,
    }
}

function SessionReportsModal(props) {
    const { jobId, ownerPartyId, ownerPartyName, jobName } = props
    const fileTypes = props.fileTypes || []
    const theme = useTheme()
    const matchesSM = useMediaQuery(theme.breakpoints.up('sm'))
    const matchesMD = useMediaQuery(theme.breakpoints.up('md'))
    const displayableFileTypes = [1, 4, 140]

    const [openModal, setOpenModal] = useState(false)
    const [error, setError] = useState('')
    const [jobDataNotFound, setJobDataNotFound] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [files, setFiles] = useState([])
    const dispatch = useDispatch()


    useEffect(() => {
        if (!jobId || !ownerPartyId) {
            setError(true)
        }

        const loadAssociatedFiles = async() => {
            dispatch(loadWorkorderAssociatedFiles(jobId)).then(
                woFiles => {
                    if (!woFiles.error && woFiles.length > 0) {
                        setJobDataNotFound(false)
                        const fileData = woFiles.map((file) => {
                            const fileType = fileTypes.find(f => f.id == file.fileTypeId)

                            return {
                                hasDetailView: fileType ? fileType.hasDetailView : false,
                                requiresConversion: fileType ? fileType.requiresConversion : false,
                                Id: file.id,
                                Name: file.name,
                                FileTime: file.fileTime,
                                FieldComputerId: file.systemName,
                                SystemName: file.systemName,
                                FileTypeId: file.fileTypeId,
                                FileType: fileType ? fileType.typeName : null,
                                OwnerPartyId: file.ownerPartyId,
                                ClientFileName: file.clientFileName,
                                ServerFileName: file.serverFileName,
                            }
                        })
                        setFiles([...fileData])
                    }
                    else if ((woFiles.error && woFiles.error.response.status === 404) || woFiles.length === 0) {
                        setJobDataNotFound(true)
                    }
                    else {
                        setError(true)
                    }
                })
            setIsLoading(false)
        }

        if (openModal) {
            loadAssociatedFiles()
        }

    }, [openModal])

    return (
        <>
            <Button sx={{margin: '5px'}} variant="outlined" onClick={() => setOpenModal(true)}>
                Session Reports
            </Button>
            <Modal open={openModal} hideBackdrop={false} style={{
                backdropFilter: 'blur(5px)',
            }}>
                <Box sx={{ ...modalStyle, paddingX: matchesSM ? 4 : 2, paddingTop: matchesSM ? 3 : 2 }}>
                    {matchesMD && <>
                        <Typography variant={'h6'}
                            style={{ fontWeight: 500, display: 'inline-block' }}>{jobName}</Typography>
                        <Typography
                            style={{ float: 'right', display: 'inline-block', border: 'none', padding: '5px 15px 0px 0px' }}>
                            {ownerPartyName}
                        </Typography>
                    </>}
                    {!matchesMD && <>
                        <Typography variant={'subtitle2'} style={{ display: 'inline-block', fontWeight: 350 }}>
                            {ownerPartyName}
                        </Typography>
                        <br/>
                        <Typography variant={'h6'} style={{ fontWeight: 500, display: 'inline-block' }}>
                            {jobName}
                        </Typography>
                    </>}
                    <IconButton
                        aria-label="close"
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: 'grey',
                        }}
                        onClick={() => setOpenModal(false)}>
                        <CloseIcon />
                    </IconButton>
                    <br/><br/>
                    <div style={{ backgroundColor: '#004668', color: 'white', borderRadius: '10px 10px 5px 5px' }}>
                        <Typography
                            style={{
                                paddingTop: '8px',
                                paddingBottom: '7px',
                                fontWeight: 'normal',
                                textAlign: 'center',
                                fontSize: 'large',
                            }}
                        >
                            Associated Session Report Files
                        </Typography>
                    </div>
                    <Stack sx={{ height: '200px', paddingTop: '10px', overflowY: 'auto' }} spacing={2}>
                        {(!isLoading && error) && <div style={{ ...centeredText }}> Error Loading Files </div>}
                        {isLoading && <div id="loading-container">
                            <CircularProgress sx={{marginLeft: '48%'}}/>
                        </div>}
                        {(!isLoading && jobDataNotFound) && <div style={{ ...centeredText }}> No Files Found </div>}
                        {(!isLoading && !jobDataNotFound) && <ReportTable sx={{ layoutMode: 'grid-no-grow' }}>
                            <ReportTable.Body>
                                {files
                                    .filter(file => displayableFileTypes.includes(file.FileTypeId))
                                    .sort((a, b) => {
                                        const dateA = a.FileTime ? new Date(a.FileTime).getTime() : 0
                                        const dateB = b.FileTime ? new Date(b.FileTime).getTime() : 0

                                        return dateB - dateA
                                    })
                                    .map(file => (
                                        <ReportTable.Row key={'file_row_' + file.Id} id={'file_row_' + file.Id}>
                                            {['Name', 'FileType', 'FileTime', 'SystemName'].map(column => (
                                                <StyledTableNameCell key={'cell_' + column + '_' + file.Id}>
                                                    {displayCell(file, column)}
                                                </StyledTableNameCell>
                                            ))}
                                        </ReportTable.Row>
                                    ))}
                            </ReportTable.Body>
                        </ReportTable>}
                    </Stack>

                    <Paper square elevation={0} sx={{ display: 'inline-block', float: 'right', margin: '5px 10px 0px 0px' }}>
                        <Button onClick={() => setOpenModal(false)} size={'large'}> Close </Button>
                    </Paper>
                </Box>
            </Modal>
        </>
    )
}
export default connect(mapStateToProps)(SessionReportsModal)
